import React from 'react';
import { useLocation } from '@tanstack/react-router';
import {
  Layout,
  Card,
} from '@piwikpro/ui-components';
import { withInject } from '@piwikpro/platform';
import IPAnonimization from './IPAnonimization';

export interface GlobalPrivacySettingsProps {
  Title: React.ComponentType<any>
  t: Function
}

export const GlobalPrivacySettings: React.FC<GlobalPrivacySettingsProps> = ({
  Title,
  t,
}) => {
  const { pathname } = useLocation();

  return (
    <Title
      part={t('platform.privacySettings.title')}
      update={pathname.includes('/privacy')}
    >
      <Layout>
        <Layout.AnnotatedSection
          title={t('apps.details.privacy.ip-addresses.title')}
        />
        <Layout.Column dominant>
          <Card>
            <IPAnonimization />
          </Card>
        </Layout.Column>
      </Layout>
    </Title>
  );
};

export default withInject({
  Title: 'TitleCrate.components.Title',
})(GlobalPrivacySettings as any);
